
import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class AuditService {

    static getAudits(page, maxPerPage, CompanyCode, Email, Action , startdate, enddate) {
        //var data = [];
        return axios.get(`${BaseUrl}Audit?page=${page}&maxPerPage=${maxPerPage}&CompanyCode=${CompanyCode ? CompanyCode : ''}` +
            `&email=${Email ? Email : ''}&action=${Action ? Action : ''}&startdate=${startdate ? startdate : ''}&enddate=${enddate ? enddate : ''}`);
    }
   
}


// WEBPACK FOOTER //
// ./src/Services/auditService/auditService.js